import { __awaiter, __extends, __generator } from "tslib";
import { logTaggedMessage } from '../reporter';
import { Deferred, stringify } from '../../utils';
import { isNextActionChallenge, isNextActionFingerprint, isNextActionRedirect, isNextActionRetry, isNextActionV1Fallback, } from './3ds-utils';
import { performChallenge as adyenChallenge } from './adyen/adyen-challenge';
import { performFingerprint as adyenFingerprint } from './adyen/adyen-fingerprint';
import { performV1Fallback as adyenV1Fallback } from './adyen/adyen-v1fallback';
import { collectBrowserInfo } from './collectBrowserInfo';
import { performChallenge as worldpayChallenge } from './worldpay/worldpay-challenge';
import { performFingerprint as worldpayFingerprint } from './worldpay/worldpay-fingerprint';
import { performV1Fallback as worldpayV1Fallback } from './worldpay/worldpay-v1fallback';
import { redirectAction } from './redirect/redirect-action';
import { setCustomErrorType } from '../custom-error-utils';
import { createVisibleIframe, createHiddenIframe, postToIframe, updateIframeSourceUsingGetRequest, } from './iframe-handler';
var HIDDEN_TIMEOUT_MS = 30000;
var VISIBLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 min
var log = logTaggedMessage({ module: '3ds' });
export var performAuthenticationSteps = function (callServerSubmit) { return __awaiter(void 0, void 0, void 0, function () {
    var res, lastCalledProvider, threeDsNextAction, data, data, performFingerprint, threeDsData, data, performChallenge, threeDsData, data, performV1Fallback, threeDsData, data, threeDsData;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, performInitialSubmit(callServerSubmit, lastCalledProvider)];
            case 1:
                res = _c.sent();
                _c.label = 2;
            case 2:
                if (!(res.threeDsNextAction || ((_a = res.nextAction) === null || _a === void 0 ? void 0 : _a.threeDsNextAction))) return [3 /*break*/, 18];
                log("3ds: received nextAction", { 'received server response': res });
                threeDsNextAction = (res.threeDsNextAction ||
                    ((_b = res.nextAction) === null || _b === void 0 ? void 0 : _b.threeDsNextAction));
                if (!isNextActionRetry(threeDsNextAction)) return [3 /*break*/, 4];
                data = threeDsNextAction.retry;
                return [4 /*yield*/, performRetrySubmit(data, callServerSubmit)];
            case 3:
                res = _c.sent();
                return [3 /*break*/, 17];
            case 4:
                if (!isNextActionFingerprint(threeDsNextAction)) return [3 /*break*/, 7];
                data = threeDsNextAction.deviceFingerprint;
                lastCalledProvider = data.provider;
                performFingerprint = getProviderStrategy(data.provider.providerType)
                    .fingerprint;
                return [4 /*yield*/, performFingerprint(data)];
            case 5:
                threeDsData = _c.sent();
                log("3ds: calling server submit after fingerprint", {
                    threeDsData: threeDsData,
                });
                return [4 /*yield*/, callServerSubmit(threeDsData)];
            case 6:
                res = _c.sent();
                return [3 /*break*/, 17];
            case 7:
                if (!isNextActionChallenge(threeDsNextAction)) return [3 /*break*/, 10];
                data = threeDsNextAction.challenge;
                lastCalledProvider = data.provider;
                performChallenge = getProviderStrategy(data.provider.providerType)
                    .challenge;
                return [4 /*yield*/, performChallenge(data)];
            case 8:
                threeDsData = _c.sent();
                log("3ds: calling server submit after Challenge", {
                    threeDsData: threeDsData,
                });
                return [4 /*yield*/, callServerSubmit(threeDsData)];
            case 9:
                res = _c.sent();
                return [3 /*break*/, 17];
            case 10:
                if (!isNextActionV1Fallback(threeDsNextAction)) return [3 /*break*/, 13];
                data = threeDsNextAction.v1Fallback;
                lastCalledProvider = data.provider;
                performV1Fallback = getProviderStrategy(data.provider.providerType)
                    .fallback;
                return [4 /*yield*/, performV1Fallback(data)];
            case 11:
                threeDsData = _c.sent();
                log("3ds: calling server submit after v1fallback", {
                    threeDsData: threeDsData,
                });
                return [4 /*yield*/, callServerSubmit(threeDsData)];
            case 12:
                res = _c.sent();
                return [3 /*break*/, 17];
            case 13:
                if (!isNextActionRedirect(threeDsNextAction)) return [3 /*break*/, 16];
                data = threeDsNextAction.redirect;
                lastCalledProvider = data.provider;
                return [4 /*yield*/, redirectAction(data)];
            case 14:
                threeDsData = _c.sent();
                log("3ds: calling server submit redirect action (payments)", {
                    threeDsData: threeDsData,
                });
                return [4 /*yield*/, callServerSubmit(threeDsData)];
            case 15:
                res = _c.sent();
                return [3 /*break*/, 17];
            case 16: throw Error("unexpected serverResponse.threeDsNextAction ".concat(stringify(threeDsNextAction)));
            case 17: return [3 /*break*/, 2];
            case 18: return [2 /*return*/, res];
        }
    });
}); };
var getProviderStrategy = function (providerType) {
    switch (providerType) {
        case 'ADYEN':
            return {
                fingerprint: adyenFingerprint,
                challenge: adyenChallenge,
                fallback: adyenV1Fallback,
            };
        case 'WORLDPAY':
            return {
                fingerprint: worldpayFingerprint,
                challenge: worldpayChallenge,
                fallback: worldpayV1Fallback,
            };
        default:
            return {
                fingerprint: worldpayFingerprint,
                challenge: worldpayChallenge,
                fallback: worldpayV1Fallback,
            };
    }
};
var ThreeDsTimeoutException = /** @class */ (function (_super) {
    __extends(ThreeDsTimeoutException, _super);
    function ThreeDsTimeoutException(timeout) {
        var _this = this;
        var message = "ERR314: a timeout of ".concat(timeout, "ms was reached while waiting for 3d-secure result");
        _this = _super.call(this, message) || this;
        _this.name = 'ThreeDsTimeoutException';
        _this.message = message;
        setCustomErrorType(_this, ThreeDsTimeoutException);
        return _this;
    }
    return ThreeDsTimeoutException;
}(Error));
export { ThreeDsTimeoutException };
var ThreeDsFormattingException = /** @class */ (function (_super) {
    __extends(ThreeDsFormattingException, _super);
    function ThreeDsFormattingException(message) {
        var _this = _super.call(this, message) || this;
        _this.name = 'ThreeDsFormattingException';
        _this.message = message;
        setCustomErrorType(_this, ThreeDsTimeoutException);
        return _this;
    }
    return ThreeDsFormattingException;
}(Error));
export { ThreeDsFormattingException };
export var listenTo3dsResult = function (_a) {
    var timeout = _a.timeout, fromWindow = _a.fromWindow, cancel = _a.cancel, originToValidate = _a.originToValidate;
    var listenPromise = listenFromWindow(fromWindow, originToValidate).then(function (msg) { return msg.data; });
    var _b = rejectOnTimeout(timeout), timeoutPromise = _b.timeoutPromise, clearTimeout = _b.clearTimeout;
    var promises = [timeoutPromise, listenPromise];
    if (typeof cancel !== 'undefined') {
        promises.push(cancel);
    }
    return Promise.race(promises).finally(function () {
        clearTimeout();
    });
};
export var performInitialSubmit = function (callServerSubmit, failedProvider) {
    var threeDsData = {
        browserInfo: collectBrowserInfo(),
        challengeDisplaySize: getThreeDsChallengeDisplaySize(),
        provider: undefined,
        failedProvider: failedProvider,
    };
    return callServerSubmit({
        initialData: threeDsData,
    });
};
export var performRetrySubmit = function (_a, callServerSubmit) {
    var provider = _a.provider;
    var threeDsData = {
        browserInfo: collectBrowserInfo(),
        challengeDisplaySize: getThreeDsChallengeDisplaySize(),
        provider: provider,
        failedProvider: undefined,
    };
    log("3ds: calling server submit for Retry at ".concat(provider.providerType), {
        threeDsData: threeDsData,
    });
    return callServerSubmit({
        initialData: threeDsData,
    });
};
export var getThreeDsChallengeDisplaySize = function () {
    return 'SMALL';
};
var rejectOnTimeout = function (ms) {
    var timerId;
    var timeoutPromise = new Promise(function (_resolve, reject) {
        timerId = setTimeout(function () {
            return reject(new ThreeDsTimeoutException(ms));
        }, ms);
    });
    return {
        timeoutPromise: timeoutPromise,
        clearTimeout: function () {
            timerId && clearTimeout(timerId);
        },
    };
};
var listenFromWindow = function (fromWindow, originToValidate) {
    return new Promise(function (resolve) {
        window.addEventListener('message', function (e) {
            log("3ds: message recived back from iframe", {
                origin: e.origin,
                data: e === null || e === void 0 ? void 0 : e.data,
                originToValidate: originToValidate,
            });
            var isSameSource = e.source === fromWindow;
            var isSameOrigin = originToValidate
                ? e.origin === originToValidate
                : true;
            if (isSameSource && isSameOrigin) {
                log("3ds: message source from 3ds ifrmae confirmed ", {
                    origin: e.origin,
                    data: e === null || e === void 0 ? void 0 : e.data,
                });
                resolve(e);
            }
        }, false);
    });
};
export var renderIframeAndWaitForPostback = function (type, methodUrl, iframeMethodType, requestRawPostData, originToValidate) {
    var cancelByUser = new Deferred();
    var iframeName = type === 'hidden'
        ? createHiddenIframe()
        : createVisibleIframe(cancelByUser);
    var timeout = process.env.NODE_ENV !== 'production' && window.override3dsTimeout
        ? window.override3dsTimeout
        : type === 'hidden'
            ? HIDDEN_TIMEOUT_MS
            : VISIBLE_TIMEOUT_MS;
    log("3ds: rendering ".concat(type, " iframe, listening for postMessage from it"), {
        methodUrl: methodUrl,
        requestRawPostData: requestRawPostData,
        iframeName: iframeName,
        timeout: timeout,
    });
    var resultPromise = listenTo3dsResult({
        timeout: timeout,
        fromWindow: window.frames[iframeName],
        cancel: cancelByUser.promise,
        originToValidate: originToValidate,
    });
    if (iframeMethodType === 'GET') {
        updateIframeSourceUsingGetRequest({
            url: methodUrl,
            iframeName: iframeName,
        });
    }
    else {
        postToIframe({
            url: methodUrl,
            fields: requestRawPostData,
            iframeName: iframeName,
        });
    }
    return resultPromise;
};
//# sourceMappingURL=3d-secure.js.map